import { scrollElementEntrance } from './animations.js';

const handleIntersectionObserver = (entries, observer) => {
    entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        scrollElementEntrance(entry.target);
        observer.unobserve(entry.target);
    });
};

const scrollObserver = new IntersectionObserver(handleIntersectionObserver, {
    rootMargin: '0px 0px -10% 0px',
});

const initScrollWaypoints = (els) => {
    els.forEach((el) => scrollObserver.observe(el));
};

export { initScrollWaypoints as default };
